import type { ComponentProps, PropsWithChildren } from 'react';

import { WellhubLogo } from 'components/organisms/WellhubLogo';
import { LanguageSelection } from 'components/templates/LanguageSelection';
import { useUscWellhubFlow } from 'hooks/useUscWellhubFlow';

import * as S from './Header.style';

type HeaderProps = Readonly<
  PropsWithChildren<
    {
      style?: {
        $backgroundColor?: string;
        $secondaryBackgroundColor?: string;
      };
    } & ComponentProps<typeof WellhubLogo>
  >
>;

export function Header({ style, children, ...logoLinkProps }: HeaderProps) {
  const { $backgroundColor, $secondaryBackgroundColor } = style ?? {};
  const isUscWellhubFlow = useUscWellhubFlow();

  return (
    <S.Header $backgroundColor={$backgroundColor}>
      <S.Logo>
        <WellhubLogo
          {...logoLinkProps}
          variant={isUscWellhubFlow ? 'wellhub-usc' : 'wellhub'}
        />
      </S.Logo>

      <S.Content $secondaryBackgroundColor={$secondaryBackgroundColor}>
        {children}

        <LanguageSelection />
      </S.Content>
    </S.Header>
  );
}
